/**
 * Created by zuozhuo on 2018/3/8.
 */

import React from "react";
import PropTypes from "prop-types";
import { ActivityIndicator } from "foui";
import classnames from "classnames";
import "./index.scss";

class LoadingView extends React.Component {
  render() {
    const { loading, inline, theme, ...others } = this.props;
    const { toast } = this.props;
    if (loading) {
      // 如果既不是inline形式, 也不是toast形式, 那么就是绝对位置居中
      const isAbsoluteCenter = !inline && !toast;
      return (
        <ActivityIndicator
          className={classnames("LoadingView-loading", `theme-${theme}`, {
            "absolute-center": isAbsoluteCenter,
            "is-inline": inline
            // "bx-absolute-center-h": !fullCover
          })}
          {...others}
        />
      );
    }
    return this.props.children || null;
  }
}

LoadingView.propTypes = {
  loading: PropTypes.bool.isRequired,
  inline: PropTypes.bool,

  size: PropTypes.string, //     size?: 'large' | 'small';
  toast: PropTypes.bool,
  text: PropTypes.node,
  theme: PropTypes.string // dark | light
};
LoadingView.defaultProps = {
  loading: true,
  inline: false,

  size: "small",
  toast: false,
  text: "加载中",
  theme: "light"
};

export default LoadingView;



// WEBPACK FOOTER //
// ./src/components/LoadingView/index.js